<template>
    <div class="field">
        <label v-if="label">{{ label }}</label>

        <div class="control" :class="{
            'has-icons-right': right_icon,
            'has-icons-left': icon,
            'is-loading': loading
        }">

            <input
                ref="input"
                v-bind="$attrs"
                v-validate="validate"
                :data-vv-validate-on="validate_on"
                v-on="listeners"
                :name="name"
                :class="['input', input_class, {'is-danger': errors.has(name)}]"
                :value="value"
                :type="type || 'text'"
                @input="$emit('input', $event.target.value)"/>

            <span v-if="icon" class="icon is-small is-left">
                <i :class="['icon', icon]"></i>
            </span>

            <span
                v-if="right_icon"
                class="icon is-small is-right clickable"
                @click="$emit('right_icon_click')">
                <i :class="['icon', right_icon]"></i>
            </span>
        </div>

        <p class="help is-danger">{{ errors.first(name) }}</p>
    </div>
</template>

<script>
export default {
    name: 'Input',
    inheritAttrs: false,
    props: {
        icon: String,
        right_icon: String,
        name: String,
        value: [String, Number],
        validate: String,
        validate_on: { type: String, default: 'input' },
        input_class: { type: String, default: '' },
        type: String,
        label: String,
        loading: Boolean,
    },
    inject: ['$validator'],
    computed: {
        listeners() {
            const { input, ...listeners } = this.$listeners;
            return listeners;
        },
    },
};
</script>

<style scoped>
    .clickable {
        pointer-events: initial !important;
        cursor: pointer;
    }
</style>
